import type {Directive} from 'vue';
import {intl, translationsLoadedPromise, areTranslationsLoaded} from '../utilities/translations'
import {evaluateResultWithContext} from "@/utilities/nonDomUtils";

type TranslatedHTMLElement = HTMLElement & {
    translations: {
        key:string,
        value: string
    }
};

/**
 * Dyrektywa translacji, używana jako atrybut 'translate'
 * Tekst elementu, w którym jest użyta ta dyrektywa będzie brany jako klucz translacji
 * Użycie: <span v-translate>Klucz do tłumaczeń</span>
 * Wartość atrybutu może zostać zbindowana i może podawać wartości w translacji
 * Np. <span v-translate="{ilosc: 5}">Klucz</span> gdzie Klucz = "{ilosc} dni"
 */
export default {
    /**
     *
     * @param {HTMLElement} el
     * @param binding
     */
    beforeMount: (el: TranslatedHTMLElement, binding) => {
        let translationValues = binding.value;
        let translationKey = el.innerText;
        if(el.hasAttribute('translation-key')) {
            translationKey = el.getAttribute('translation-key') || translationKey;
        } else if (el.hasAttribute('translation-key-script')) {
            translationKey = evaluateResultWithContext(el.getAttribute('translation-key-script'), binding.instance);
        }
        if (!translationKey?.length) {
            el.innerText = 'Błąd tłumaczenia';
            return;
        }
        el.translations = {
            key: translationKey,
            value: translationValues
        };
        el.innerText = intl.formatMessage({id: translationKey, defaultMessage: translationKey}, translationValues);
        if(!areTranslationsLoaded()) {
            translationsLoadedPromise.then(() => {
                translationValues = binding.value;
                el.translations = {
                    key: translationKey,
                    value: translationValues
                };
                el.innerText = intl.formatMessage({id: translationKey, defaultMessage: translationKey}, translationValues);
            })
        }
    },
    beforeUpdate: (el: TranslatedHTMLElement, binding) => {
        if(binding.value && areTranslationsLoaded() && binding.value != binding.oldValue) {
            const translationValues = binding.value;
            let translationKey = el.innerText;
            if(el.hasAttribute('translation-key')) {
                translationKey = el.getAttribute('translation-key') || translationKey;
            }
            el.translations = {
                key: translationKey,
                value: translationValues
            };
            el.innerText = intl.formatMessage({id: translationKey, defaultMessage: translationKey}, translationValues);
        }
    },
} as Directive;